import InlineEditableText from './InlineEditableText'

export default InlineEditableText
